export default __webpack_public_path__ + "static/FahimAlyi-8eb1754347a3282210ccf3cd93be60a0.png";